export default {
    url: import.meta.env.VITE_APP_KEYCLOAK_URL || 'http://localhost:8080',
    realm: import.meta.env.VITE_APP_KEYCLOAK_REALM || 'realm-eds',
    clientId: import.meta.env.VITE_APP_KEYCLOAK_CLIENT_ID || 'eds-front-client',
    tokenUrl: import.meta.env.VITE_APP_KEYCLOAK_TOKEN_URL || null,
}
